import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import RemoteLayout from "./layout";
import { WorkshopContext } from "../../contexts/workshop.context";
import dashedLynn from "../../assets/images/lynn-dashed-background.png";
import { defaultRoles } from "../../util/workshop.util";

const DEMO_WORKSHOP_IDS = {
  en: "675aa29f82fcb8dbb783e18d", // Default/English workshop ID
  fr: "679b4d34228a44092f4e78ca",
  de: "679cb402228a44092f4e78cb",
  it: "675aa29f82fcb8dbb783e18d"
};

const PreSummary = ({ demoWorkshop = false }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const baseKey = "mtParticipantStart";

  const { user: { role } = {}, workshopDetails: { _id, teamName } = {} } =
    useContext(WorkshopContext);

  useEffect(() => {
    Cookies.remove("setupCompleted");
  }, []);

  const handleSubmit = () => {
    const link = demoWorkshop
      ? `/online-demo/insights/${DEMO_WORKSHOP_IDS[i18n.language] || DEMO_WORKSHOP_IDS.en}`
      : `/online/insights/${_id}`;
    navigate(link, { state: { from: "pre-summary" } });
  };

  return (
    <RemoteLayout
      buttonText={t(`${baseKey}.joinButton`) + " →"}
      buttonColor={role === defaultRoles.participant ? "orange" : "green"}
      onButtonClick={handleSubmit}
      hideParticipantsCount={true}>
      <div className="flex flex-col items-center justify-center text-white w-full">
        <div className="mb-6 text-center">
          <h1 className="text-2xl font-semibold text-white-100">
            <span className="text-orange-default">{teamName}</span> {t(`${baseKey}.welcomeSuffix`)}
          </h1>
          <p
            className="mt-2 text-white-100"
            dangerouslySetInnerHTML={{ __html: t(`${baseKey}.instructions`) }}
          />
        </div>

        <div className="relative w-full flex flex-col md:flex-row items-center justify-center">
          <img src={dashedLynn} alt="pre-summary" className="w-96 h-96 hidden md:block" />
          {/* Form */}
          <div className="bg-orange-50 shadow-lg rounded-2xl py-10 px-6 w-full mx-auto relative">
            <p
              dangerouslySetInnerHTML={{ __html: t("preSummary.description1") }}
              className="text-xl text-gray-100 mb-4"
            />
          </div>
        </div>
      </div>
    </RemoteLayout>
  );
};

export default PreSummary;
